__turbopack_context__.v({
  "button": "JRSTdW_button",
  "fullWidth": "JRSTdW_fullWidth",
  "primary": "JRSTdW_primary",
  "secondary": "JRSTdW_secondary",
  "tertiary": "JRSTdW_tertiary",
  "tertiary-ghost": "JRSTdW_tertiary-ghost",
});
